/**
 * FM 店舗詳細ページのルートコンポーネント
 */

import { defineComponent} from 'vue'
import PointPage from "@/organizations/_default/point"


export default defineComponent({
  extends: PointPage,
  setup(props, context) {
    
    
    // 新店表示の細かい調整
    const is_new_open = storelocator?.path?.id == "new-open"
    if (is_new_open) {
      storelocator.messages.points_title = `${storelocator.messages.new_open_points_title}`
      storelocator.messages.common_back_to_map = `${storelocator.messages.back_to_new_open_map}`
    }

    const page = PointPage.setup(props, context)
    
    return {
      ...page,
    }
  }
})